function stripAndTruncate(text: string) {
    const strippedText = text
        .replace(/<\/?("[^"]*"|'[^']*'|[^>])*(>|$)/g, '') // Strip HTML
        .replace('\n', ' ')
        .replace(/[ ]{2,}/g, ' '); // Strip two or more spaces

    if (strippedText.length >= 100) {
        return strippedText.slice(0, 100).concat('...');
    }

    return strippedText;
}

type TOtherKeys = {
    [key: string]: string | number;
};

export function postDataLayerEvent(
    action: string,
    label: string = '',
    value?: number,
    other?: TOtherKeys
) {
    const dataLayerEvent = {
        event: 'ssptoolglassesEvent',
        eventAction: stripAndTruncate(action),
        eventLabel: label,
        eventValue: value,
        ...other,
    };

    window.parent.postMessage(dataLayerEvent, '*');
}
